import React from 'react'
import { Banner, Block } from '@components'

const DatoCmsBanner = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <Banner {...props} />
    </Block>
  )
}

export default DatoCmsBanner
